import { Component, OnInit } from '@angular/core';
import { DataModelService } from '@services/data-model.service';
import { Router } from '@angular/router';
import { NotificationsService } from '@services/notifications.service';

@Component({
    selector: 'app-new-data-model',
    templateUrl: './new-data-model.component.html',
    styleUrls: [
        '../data-model-prefs/data-model-prefs.component.scss',
        './new-data-model.component.scss',
    ],
    standalone: false
})
export class NewDataModelComponent implements OnInit {
  newModel = '';
  typeList = [];
  dataCategories = [];

  selectedDataCategory;

  constructor(
    private dataModelService: DataModelService,
    private router: Router,
    private notifications: NotificationsService
  ) {}

  ngOnInit() {
    this.getCatAndTypes();

    this.dataModelService.updateTypeListTrigger().subscribe(() => {
      this.getCatAndTypes();
    });
  }

  getCatAndTypes() {
    this.dataModelService.getCategories().subscribe(list => {
      this.dataCategories = list;
    });

    this.dataModelService.getTypes().subscribe(list => {
      this.typeList = list;
    });
  }

  createModel() {
    if (!this.alreadyExists() && this.newModel != '') {
      this.dataModelService
        .createType(this.newModel, this.selectedDataCategory.id)
        .subscribe(data => {
          if (data.errorMessage) {
            this.notifications.popNotification(data.errorMessage, 'X');
          } else {
            this.selectedDataCategory = null;

            this.notifications.popNotification(
              this.newModel + ' created',
              'X',
              5
            );
            this.newModel = '';
            this.dataModelService.updateTypes();
            // this.router.navigateByUrl('/data-models');
          }
        });
    }
  }

  alreadyExists() {
    var typeExists = false;

    for (var i = 0; i < this.typeList.length; i++) {
      var type = this.typeList[i];

      if (this.newModel + '__c' == type.name) {
        typeExists = true;
        break;
      }
    }

    return typeExists;
  }
}
